<template>
  <div class="slider-animation-slow a-vs-header--main-slider">
    <div class="slides-container">
      <div class="wrapper">
        <transition name="slide">
          <jackpot-fall-stadium
            v-if="isStadium"
            :ticketLocation="ticketLocation"
            :jackpotAmount="jackpotAmount"
            :ticketNo="ticketNo"
            :currency="currency" />
        </transition>
      </div>
      <div class="wrapper">
        <transition name="slide">
          <jackpot-fall-champion
              v-if="isChampion"
              :ticketLocation="ticketLocation"
              :jackpotAmount="jackpotAmount"
              :ticketNo="ticketNo"
              :currency="currency" />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>

import JackpotsFallStadium from '@/components/soccer/slides/JackpotsFallStadiumSlide.vue'
import JackpotsFallChampion from '@/components/soccer/slides/JackpotsFallChampionSlide.vue'

export default {
  components: {
    'jackpot-fall-stadium': JackpotsFallStadium,
    'jackpot-fall-champion': JackpotsFallChampion
  },
  props: {
    showSlider: {
      type: String,
      required: true
    },
    ticketLocation: {
      type: String,
      required: true
    },
    jackpotAmount: {
      type: Number,
      required: true
    },
    currency: {
      type: String,
      required: true
    },
    ticketNo: {
      type: String,
      required: true
    }
  },
  computed: {
    isStadium: function () {
      return this.showSlider === 'Stadium'
    },
    isChampion: function () {
      return this.showSlider === 'Champion'
    }
  }
}

</script>
